import React, { useCallback, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import { Variant, Size, Color } from '@prisjakt/ui-button/src/types';

type Props = {
  property?: string;
  disabled?: boolean;
  onClick?: () => void;
  variant?: Variant;
  size?: Size;
  color?: Color;
  className?: string;
  clearFilter: (property?: string) => void;
};

const ClearButton = ({
  property,
  onClick,
  disabled,
  variant,
  color,
  size,
  className,
  clearFilter,
}: Props) => {
  const { t } = useContext(AppContext);
  const onClickHandler = useCallback(() => {
    if (typeof onClick === 'function') {
      onClick();
    }
    clearFilter(property);
  }, [onClick, clearFilter, property]);
  return (
    <Button
      className={className}
      variant={variant}
      color={color}
      size={size}
      onClick={onClickHandler}
      disabled={disabled}
      data-test="FeaturedFilterClear"
    >
      {t('filter', 'button.clear-filter')}
    </Button>
  );
};

export default ClearButton;
